import React from 'react'
import {isAuthMode} from 'src/shared/config'

import {useIsMobile} from '../../../../hooks'
import {ModalDesktop} from './ModalDesktop'
import {ModalMobile} from './ModalMobile'
import {ModalMobileAuth} from './ModalMobileAuth'
import type {Props} from './types'

export function Modal(props: Props): React.ReactElement<Props> {
  const isMobile = useIsMobile()

  if (!isMobile) {
    return <ModalDesktop {...props} />
  }

  return isAuthMode ? <ModalMobileAuth {...props} /> : <ModalMobile {...props} />
}
